// KWANKGM00260_マイページ開設認証
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Block from '../../molecules/Block';
import axios from 'axios';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import Heading from '../../molecules/Heading';
import Text from '../../molecules/Text';
import TransitionButton from '../../molecules/TransitionButton';
import { http_status_code_list } from '../../Const';
import { KWANKGM00060A02 } from '../../const/api_modules';

const EntryAuthenticate = () => {
  // 入力値を格納する
  const [authenticate_code, setAuthenticateCode] = useState<string>('');
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState<boolean>(false);
  // エラーメッセージ
  const [error_authenticate_code, setErrorAuthenticateCode] = useState<string>('');

  const email = document.getElementById('entry_authenticate')?.dataset.email;

  // 案件ID、CD取得
  const node = document.getElementById('entry_authenticate');
  const r_cd = node?.dataset.r_cd as string;
  const r_id = Number(node?.dataset.r_id as string);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  // 「認証コードを送信する」ボタン押下時
  const executeAuthenticateCode = async () => {
    try {
      setErrorAuthenticateCode('');
      setIsLoading(true);

      // タブ毎にセッションを管理する為のUUIDを取得する
      const url = new URL(location.href);
      const uuid = url.searchParams.has('uuid')
        ? url.searchParams.get('uuid')
        : sessionStorage.getItem('uuid');

      //  認証コードが有効か判定し、マイページ開設処理、ユーザ同意登録処理
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/entry/execute_entry_authenticate`,
        {
          authenticate_code,
          uuid,
        }
      );

      if (response.data.mypage_onend) {
        // マイページ開設済みの場合は、マイページ開設済表示画面に遷移する
        return location.replace(response.data.url);
      }

      if (response.data.result && r_cd && r_id) {
        // 借入申込案件作成処理
        await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
          module_name: KWANKGM00060A02,
          reception_cd: r_cd,
          reception_id: r_id,
        });
      }

      if (response.data.result) {
        // マイページ開設完了画面へ遷移する
        location.replace(response.data.url);
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      if (error.response.data.statusCode === http_status_code_list.unauthorized) {
        // バリデーションエラーの場合
        setErrorAuthenticateCode(error.response.data.message);
      } else {
        // システムエラー
        alert(error.response.data.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // 「戻る」ボタン押下時
  const backTransition = () => {
    // パラメータを取得
    const url_params = new URLSearchParams(document.location.search.substring(1));
    const email = encodeURIComponent(url_params.get('email') ?? '');
    const name = url_params.get('name');
    const ja_code = url_params.get('ja_code');
    const usage_pattern = url_params.get('usage_pattern');

    // リファラからURLを生成
    const refere = document.referrer ?? sessionStorage.getItem('mypage_entry_url');
    const refere_url = new URL(refere);
    const refere_params = new URLSearchParams(refere_url.search);

    if (refere_params.get('mail') || refere_params.get('name')) {
      // マイページなしで事前審査を進めて、事前審査結果画面からマイページ開設・マイページ開設招待メールからの開設の場合
      location.href = `${location.origin}${process.env.MIX_MOCK_URL}/entry?mail=${email}&name=${name}&jacode=${ja_code}&usage_pattern=${usage_pattern}`;
    } else {
      // JAネットローンHPのリンクからの開設の場合
      location.href = `${location.origin}${process.env.MIX_MOCK_URL}/entry?input_email=${email}&input_name=${name}&jacode=${ja_code}&usage_pattern=${usage_pattern}`;
    }
  };

  return (
    <>
      <Heading label="マイページ開設認証" bold={true} size="l" />
      <Block
        label="認証コード入力"
        content={
          <>
            <div className="container-box">
              <div>
                <div className="p-lead my-3">
                  {email}に認証コードを送信しました。
                  <br />
                  受信したメールに表示されている認証コードをご入力下さい。
                  <br />
                  認証コードの有効期限はメール発行後30分です。
                </div>
                <div className="mt-3">
                  <Text
                    id="authenticate_code"
                    label="認証コード"
                    type="text"
                    value={authenticate_code}
                    placeholder=""
                    handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setAuthenticateCode(event.target.value);
                    }}
                    disabled={false}
                    message={error_authenticate_code}
                    display_border={true}
                  />
                </div>
                <div className="p-lead my-3">
                  確認メールは「no-reply@entry.ja-netloan.jp」から送信されます。
                  <br />
                  メールが届かない場合、メールアドレスのご確認、「no-reply@entry.ja-netloan.jp」から受信可能なメール設定であるかのご確認をいただき、前のページから再度送信をお願いいたします。
                </div>
                <div className="content-box">
                  <button
                    className="c-btn btn-max btn-green btn-arrow-right mx-auto mb-5"
                    type="button"
                    onClick={executeAuthenticateCode}
                  >
                    認証コードを送信する
                  </button>
                  <div>
                    <TransitionButton label="戻る" handleClick={backTransition} />
                  </div>
                </div>
                <LoadingModal show={is_loading} />
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

if (document.getElementById('entry_authenticate')) {
  render(<EntryAuthenticate />, document.getElementById('entry_authenticate'));
}
